import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DesignationAdapter } from './dto/designation.adapter';
import { DesignationController } from './designation.controller';
import { Designation } from './designation.entity';
import { DesignationService } from './designation.service';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([Designation]),
  ],
  controllers: [DesignationController],
  providers: [DesignationService, DesignationAdapter, ApplicationExceptionHandler,LogsService],
  exports: [DesignationService]
})
export class DesignationModule {}
